export enum AICopilotScope {
    TextToSong,
    TextToMIDI,
    SoundAI,
    Library
}
